<template>
    <div>
        <div class="alert alert--danger" v-if="error.show">
            {{ error.text }}
        </div>
        <div class="game" v-show="!error.show && game">
            <div class="game-component">
                <div class="game">
                    <div class="game-component">
                        <div class="casino-play__wrapper-place" id="game-wrapper">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            game: null,
            error: {
                show: false,
                text: ''
            },
        }
    },
    mounted() {
        window.addEventListener('message', this.handleMessage);
        this.getGame();
    },

    unmounted() {
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        handleMessage(e) {
            if (e.data === 'reload-game') {
                this.$router.push({ name: 'slots' });
            }
        },
        getGame() {
            this.$root.isLoading = true;

            this.$root.axios.post('/api/slots/init', {
                game_id: this.$route.params.gameId
            })
                .then(res => {
                    this.game = res.data;

                    this.initLaunchGame();
                }).catch(error => {
                    
                    this.error = {
                        show: true,
                        text: this.$root.graphql.axiosGetError(error)
                    };
                })

            this.$root.isLoading = false;
        },
        initLaunchGame() {
            this.$root.isLoading = false;

            let gameLaunchOptions = { target_element: 'game-wrapper' };
            gameLaunchOptions['launch_options'] = {
                game_launcher_url: this.game?.url?.launch_options?.game_launcher_url ?? 'https://cdn.launcher.a8r.games/scripts/gamelauncher/index.html',
                game_url: this.game?.url?.launch_options?.game_url ?? this.game?.url,
                strategy: this.game?.url?.launch_options?.strategy ?? 'detect',
            };

            this.$root.$launcher.launch(gameLaunchOptions);
        }
    },
    watch: {
        '$route.params.gameId'(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.game = null;
                this.$root.isLoading = true;
                this.getGame();
            }
        }
    }
}
</script>

<style scoped>
.game {
    display: -webkit-flex;
    display: flex;
    width: 100%;
    -webkit-align-items: stretch;
    align-items: stretch;
    position: relative
}

.game-component {
    -webkit-align-items: stretch;
    align-items: stretch;
    width: 100%;
    position: relative
}

.casino-play__wrapper-place {
    position: relative;
    width: 100%;
    height: 85vh;
}

.casino-play__wrapper-place iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
}
.game-block, .game-component {
    background: none;
}
</style>